module.exports = __webpack_public_path__ + "media/images/mbd-benefits@2x-aedf5706eefb311ec112befc5935ca65.webp";